/**
 * Площади
 */
export default class WapiRadarStatistics {
  constructor(userId = '') {
    this.user_id = userId;
    this.radar_statistics_days = [];
  }
}